import React from 'react';

export function Select({ label, value, onChange, options = [], placeholder = 'Select…', required = false, disabled = false, style = {}, ...rest }) {
  const [focus, setFocus] = React.useState(false);
  return (
    <label style={{ display: 'block', ...style }}>
      {label && (
        <span style={{ display: 'block', marginBottom: 'var(--space-2)', fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-sm)', fontWeight: 'var(--fw-semibold)', color: 'var(--text-strong)' }}>
          {label}{required && <span style={{ color: 'var(--danger)' }}> *</span>}
        </span>
      )}
      <div style={{ position: 'relative', height: 'var(--control-h-md)', background: disabled ? 'var(--surface-sunken)' : 'var(--surface-card)', border: `1.5px solid ${focus ? 'var(--accent)' : 'var(--border-strong)'}`, borderRadius: 'var(--radius-md)', boxShadow: focus ? '0 0 0 4px var(--ring)' : 'none', transition: 'border-color var(--dur-fast), box-shadow var(--dur-fast)' }}>
        <select value={value} onChange={onChange} disabled={disabled} required={required}
          onFocus={() => setFocus(true)} onBlur={() => setFocus(false)}
          style={{ appearance: 'none', WebkitAppearance: 'none', width: '100%', height: '100%', border: 'none', outline: 'none', background: 'transparent', padding: '0 40px 0 14px', fontFamily: 'var(--font-body)', fontSize: 'var(--fs-body)', color: value ? 'var(--text-strong)' : 'var(--text-muted)', cursor: 'pointer' }}
          {...rest}>
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((o) => {
            const val = typeof o === 'string' ? o : o.value;
            const lab = typeof o === 'string' ? o : o.label;
            return <option key={val} value={val}>{lab}</option>;
          })}
        </select>
        <span style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: 'var(--text-muted)', fontSize: 12 }}>▾</span>
      </div>
    </label>
  );
}
